var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-spin",
    { attrs: { spinning: _vm.formOption.busy } },
    [
      _c(
        "a-form",
        {
          attrs: {
            form: _vm.form,
            "label-col": { span: 6 },
            "wrapper-col": { span: 13 },
          },
        },
        [
          _c(
            "a-form-item",
            { attrs: { label: "模型标识" } },
            [
              _c("a-input", {
                directives: [
                  {
                    name: "decorator",
                    rawName: "v-decorator",
                    value: ["key", _vm.rules.key],
                    expression: "['key',rules.key]",
                  },
                ],
              }),
            ],
            1
          ),
          _c(
            "a-form-item",
            { attrs: { label: "模型名称" } },
            [
              _c("a-input", {
                directives: [
                  {
                    name: "decorator",
                    rawName: "v-decorator",
                    value: ["name", _vm.rules.name],
                    expression: "['name',rules.name]",
                  },
                ],
              }),
            ],
            1
          ),
          _c(
            "a-form-item",
            { attrs: { label: "描述" } },
            [
              _c("a-input", {
                directives: [
                  {
                    name: "decorator",
                    rawName: "v-decorator",
                    value: ["desc"],
                    expression: "['desc']",
                  },
                ],
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "a-space",
        { staticClass: "a-form-btn-box" },
        [
          _c(
            "a-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function ($event) {
                  return _vm._save()
                },
              },
            },
            [_vm._v("提交")]
          ),
          _c(
            "a-button",
            {
              on: {
                click: function ($event) {
                  return _vm.endEdit("cancelled")
                },
              },
            },
            [_vm._v("取消")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }